<template>
    <div class="rate-offers-container" :class="{ 'no-offers': showNoOffers }">
        <transition v-if="showLoading" name="fade">
            <div class="loader">
                <img alt="lt-loader" width="61" height="60" src="../../../assets/images/offer_images.png" />
                <span>Searching for offers...</span>
            </div>
        </transition>
        <div v-if="showNoOffers">
            <div class="no-offers-found">
                <p class="text-left">Thank you for using LendingTree’s marketplace for your home <span v-show="purchRefi == 'Purchase'">loans</span><span v-show="purchRefi == 'Refinance'">refinance</span>. Unfortunately, based on the information you’ve provided, we’re unable to display rates for you at this time. Try adjusting your criteria, such as your requested loan amount, to see what lenders are waiting to offer you competitive rates.</p>
                <div class="still-no-offers">
                    <h4>Still no rate offers?</h4>
                    <p>Take a few minutes and fill out more information to get your best rate.</p>
                    <span v-if="destinationLinkOrId !== ''">
                        <a :href="getDestinationUrl(destinationLinkOrId)" class="destination-btn">Get My Rate</a>
                    </span>
                    <span v-else>
                        <a v-show="purchRefi == 'Purchase'" :href="getDestinationUrl('wp-mortgage')" class="destination-btn">Get My Rate</a>
                        <a v-show="purchRefi == 'Refinance'" :href="getDestinationUrl('wp-refinance')" class="destination-btn">Get My Rate</a>
                    </span>
                </div>
            </div>
        </div>
        <div v-if="HasData" class="rate-offers">
            <div v-for="(loanProgram, index) in loanPrograms" :key="index">
                <a
                    :id="'program-tab-' + index"
                    class="program-tab"
                    :class="index === ActiveTabIndex ? 'active' : ''"
                    href="javascript:void(0)"
                    @click="filterOfferResult(loanProgram)">{{ TabNames[loanProgram] }}</a>
                <div class="bottom-border" :class="index === ActiveTabIndex ? 'active' : ''">&nbsp;</div>
            </div>
        </div>
        <div v-if="HasData" class="tab-content">
            <div class="offer-block">
                <table class="offer-result">
                    <tbody>
                        <loan-offers
                            v-for="(offer, index) in FilteredOfferResult" :key="index"
                            :offer="offer"
                            :loan-amount="loanAmount"
                            :zip-code="zipCode"
                            :credit-band="CreditBand"
                            :home-value="homeValue"
                            :destination-link-or-id="destinationLinkOrId"
                            :destination-button-text="destinationButtonText"
                            :cta-params="ctaParams"
                        />
                    </tbody>
                </table>
            </div>
        </div>
        <div v-show="descDetails" class="disclaimer">
            The Rates, APRs, Fees, and Monthly Amounts above are estimates only and are not guaranteed. The information provided is for illustrative purposes only and is merely a conditional quote subject to change, may not be available in all states, and are based on loan amount requested and creditworthiness as determined by the lender selected. Your financial information will be required to be verified and subject to formal credit approval by the lender selected. LendingTree receives payment from the lenders Mortgage offers that appear on this site are from companies from which LendingTree receives compensation. This compensation may impact how and where products appear on this site (including for example, the order in which they appear or whether a lender is "featured" on the site). LendingTree does not include all Mortgage companies or all types of offers available in the marketplace.
            <br />
            <br />
            Mortgage Lenders determine the underwriting criteria necessary for approval; you should review each Lender's terms and conditions to determine which loan works for you and your personal financial situation. All reasonable efforts are made to provide and maintain accurate information. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to each Lender's discretion. There is no guarantee you will be approved for credit or that upon approval you will qualify for the advertised rates, fees, or terms shown. <advertising-disclosures :disclosure-id="DisclosureId" :disclosure-text="DisclosureText" :disclosure-tokens="DisclosureTokens" class="lt-howitworks disclosure-sec" />.
        </div>
        <button class="more-details-trigger" @click="showdescDetails">{{ descDetails ? 'Hide':'More' }} Details</button>
    </div>
</template>
<script>
    import LoanOffers from './loan-offers.vue';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import wwwUrlEnv from '~/helpers/www-url-env';
    import RateTableInfo from '~/mixin/rate-table-offer-tracking';

    export default {
        props: {
            creditBand: {
                default: '',
            },
            ctaParams: {
                default: '',
            },
            defaultLoanProgram: {
                default: '',
            },
            destinationButtonText: {
                default: 'Get Free Offers',
            },
            destinationLinkOrId: {
                type: String,
                default: '',
            },
            disclosureId: {
                default: 'Disclosures01',
            },
            disclosureText: {
                default: 'Learn more about how our mortgage rate table works',
            },
            disclosureTokens: {
                default: '000128',
            },
            fieldEdited: {
                default: false,
            },
            homeValue: {
                default: 0,
            },
            loanAmount: {
                default: 0,
            },
            loanPrograms: {
                default: [],
            },
            loanType: {
                default: '',
            },
            offerResult: {
                type: Array,
                default: () => [],
            },
            purchRefi: {
                default: '',
            },
            showLoading: {
                default: false,
            },
            showNoOffers: {
                default: false,
            },
            zipCode: {
                default: '',
            },
        },
        data() {
            return {
                LoanType: this.loanType,
                OfferResult: this.offerResult,
                LoanAmount: this.loanAmount,
                LoanPrograms: this.loanPrograms,
                FilteredOfferResult: this.offerResult,
                HasData: false,
                descDetails: false,
                ZipCode: this.zipCode,
                CreditBand: this.creditBand,
                HomeValue: this.homeValue,
                Offers: [],
                ShowNoOffers: this.showNoOffers,
                DisclosureText: this.disclosureText,
                DisclosureId: this.disclosureId,
                DisclosureTokens: this.disclosureTokens,
                TabNames: {
                    '15 YR FIXED': '15 Year Fixed',
                    '30 YR FIXED': '30 Year Fixed',
                },
                ActiveTabIndex: 0,
            };
        },
        methods: {
            activateTab(loanProgram) {
                this.ActiveTabIndex = this.loanPrograms.indexOf(loanProgram);
            },
            filterOfferResult(loanProgram) {
                this.activateTab(loanProgram);
                const offerResultArray = this.offerResult;
                const trackResult = [];
                let index = 1;
                if (offerResultArray) {
                    const result = [];

                    offerResultArray.forEach((offer) => {
                        if (offer.loanProgram.toLowerCase().indexOf(loanProgram.toLowerCase()) !== -1 && index < 4) {
                            offer.position = index;
                            offer.fieldEdited = this.fieldEdited;
                            result.push(offer);
                            index++;
                        }
                    });
                    this.FilteredOfferResult = null;
                    this.$nextTick(() => {
                        this.activateTab(loanProgram);
                        this.FilteredOfferResult = result;
                        trackResult.TrackOfferResult = result;
                        trackResult.fieldEdited = this.fieldEdited;
                        trackResult.loanType = this.loanType;
                        this.rateTableViewedInfo(trackResult);
                    });
                }
            },
            showdescDetails() {
                this.descDetails = !this.descDetails;
            },
            getDestinationUrl(splitter) {
                let url = `${wwwUrlEnv.getWWWURL()}/redirect/offers?id=${splitter}&icid=ratetable`;
                if (this.destinationLinkOrId !== '' && !/^[A-z0-9-]+$/i.test(this.destinationLinkOrId)) {
                    url = `${this.destinationLinkOrId}`;
                }
                return url;
            },
            getIndex(collection, text) {
                let index = collection.findIndex(element => element.toLowerCase() === text.toLowerCase());
                if (index === -1) index = 0;
                return index;
            },
        },
        watch: {
            offerResult() {
                this.HasData = this.offerResult && this.offerResult.length > 0;
                if (this.loanPrograms && this.loanPrograms.length > 0) {
                    const index = this.getIndex(this.loanPrograms, this.defaultLoanProgram);
                    this.filterOfferResult(this.loanPrograms[index]);
                }
            },
        },
        components: {
            LoanOffers,
            AdvertisingDisclosures,
        },
        mixins: [RateTableInfo],
    };
</script>
<style lang="scss">
@import "../../../assets/styles/grove/grove-colors";
@import "../../../assets/styles/grove/buttons";

.bottom-border {
    background-color: transparent;
    width: 100% !important;
    border-top-left-radius: 4px;
    height: 4px;
    border-top-right-radius: 4px;

    &.active {
        background-color: $lt-green;
    }
}

.destination-btn {
    @include button-common;
    @include button-size-medium;
    @include button-primary-blue;
    color: $white !important;
    width: 230px;
}
</style>
